import { ColumnsUtils } from 'module/Common';

export namespace Sizes {
  export enum MenuLayout {
    Mobile = 'mobile',
    Tablet = 'tablet',
    Desktop = 'desktop',
  }

  const mobileLayoutMaxWidth = 600;
  const tabletLayoutMaxWidth = 1300;

  const maxContentWidth = 1600;

  export const gutter = 40;
  export const smallGutter = 20;

  export const langTopBarHeight = 60;
  export const menuTopBarHeight = 50;

  export const bigTitleTopOverflow = 45;

  export const bigTitleLineHeght = 80;

  const leftMenuWidth = 320;

  export const getMenuWidthWithoutGutter = (windowWidth: number): number => {
    return getMenuWidth(windowWidth) - gutter * 2;
  };

  export const isMenuLogoCentered = (windowWidth: number): boolean => {
    const menuLayout = getMenuLayout(windowWidth);
    switch (menuLayout) {
      case MenuLayout.Mobile:
        return true;
      case MenuLayout.Tablet:
        return false;
      case MenuLayout.Desktop:
        return false;
    }
  };

  export const getMenuWidth = (windowWidth: number): number => {
    const menuLayout = getMenuLayout(windowWidth);
    switch (menuLayout) {
      case MenuLayout.Mobile:
        return windowWidth;
      case MenuLayout.Tablet:
        return leftMenuWidth;
      case MenuLayout.Desktop:
        return leftMenuWidth;
    }
  };

  export const getAdminBarHeght = (windowWidth: number): number => {
    if (windowWidth <= 782) {
      return 46;
    }
    return 32;
  };

  export const getMenuLayout = (windowWidth: number): MenuLayout => {
    if (windowWidth < mobileLayoutMaxWidth) {
      return MenuLayout.Mobile;
    }
    if (windowWidth < tabletLayoutMaxWidth) {
      return MenuLayout.Tablet;
    }
    return MenuLayout.Desktop;
  };

  export const getContentWidth = (windowWidth: number): number => {
    const menuLayout = getMenuLayout(windowWidth);
    switch (menuLayout) {
      case MenuLayout.Mobile:
        return windowWidth - 2 * smallGutter;
      case MenuLayout.Tablet:
        return windowWidth - 2 * gutter;
      case MenuLayout.Desktop:
        return Math.min(windowWidth - leftMenuWidth, maxContentWidth) - gutter;
    }
  };

  export const getContentMargins = (windowWidth: number): [number, number, number, number] => {
    const menuLayout = getMenuLayout(windowWidth);
    switch (menuLayout) {
      case MenuLayout.Mobile:
        return [menuTopBarHeight + smallGutter, smallGutter, smallGutter, smallGutter];
      case MenuLayout.Tablet:
        return [menuTopBarHeight + smallGutter, gutter, gutter, gutter];
      case MenuLayout.Desktop:
        return [0, gutter, gutter, leftMenuWidth];
    }
  };

  export const getMenuTopPadding = (windowWidth: number): number => {
    const menuLayout = getMenuLayout(windowWidth);
    switch (menuLayout) {
      case MenuLayout.Mobile:
        return smallGutter;
      case MenuLayout.Tablet:
        return smallGutter;
      case MenuLayout.Desktop:
        return getContentMargins(windowWidth)[0];
    }
  };

  export const getLogoMenuSize = (windowWidth: number): number => {
    const menuLayout = getMenuLayout(windowWidth);
    if (menuLayout === MenuLayout.Mobile) {
      return 1;
    }
    return 1.1;
  };

  export const getContentAdditionalTopPadding = (windowWidth: number): number => {
    const menuLayout = getMenuLayout(windowWidth);
    if (menuLayout === MenuLayout.Tablet) {
      return 60;
    }
    return 0;
  };

  export const getContentColumnsCount = (width: number): number => {
    if (width < 900) {
      return 2;
    }
    return 4;
  };

  export function isMenuAlwaysVisible(width: number): boolean {
    const layout = getMenuLayout(width);
    return layout === MenuLayout.Desktop;
  }

  export function isMenuTopBarVisible(width: number): boolean {
    const layout = getMenuLayout(width);
    return layout === MenuLayout.Mobile || layout === MenuLayout.Tablet;
  }

  export function isLangTopBarVisible(width: number): boolean {
    const layout = getMenuLayout(width);
    return layout === MenuLayout.Desktop;
  }

  export function getLangTopBarHeight(width: number): number {
    if (isLangTopBarVisible(width)) {
      return langTopBarHeight;
    }
    return 0;
  }

  export function getContentColums(width: number): ColumnsUtils.ColumnsResult {
    return ColumnsUtils.getColumns({
      availableWidth: width,
      nbOfColumns: Sizes.getContentColumnsCount(width),
      spaceBetween: smallGutter,
      spaceAround: [0, 0],
    });
  }

  export function allColumnsMinusOne(columnsCount: number): number {
    if (columnsCount <= 2) {
      return 2;
    }
    return columnsCount - 1;
  }

  export const headerVerticalOffset = (nbrOfTitleLines: number): number => {
    return Sizes.bigTitleLineHeght * nbrOfTitleLines;
  };
}



// WEBPACK FOOTER //
// ./src/module/View/Common/const/Sizes.ts